
<app-patient-info [heading]="'Dashboard'"></app-patient-info>

<ng-container>
    <div class="row p-1 pb-0">
        <div class="col-12 pageTitle">
            <h2>&nbsp;&nbsp;&nbsp;Patient Timeline</h2>
        </div>
    </div>
    <div #timeline style="height:100%;"></div>


</ng-container>
<ng-container>

    @if(selectedGroup?.content=='Labs'){

    <p-dialog *ngIf="overlayVisible" (onHide)="back();overlayVisible = false" [header]="getTitle(selectedGroup?.content)" [(visible)]="overlayVisible" modal="false" [style]="{ width: '1000px', minWidth: '200px' }" [resizable]="true">

        <div style="width:100%;">
            <div class="grid">
                <div class="col-2 card" style="overflow: auto;">
                    <p-table [value]="categories">

                        <ng-template pTemplate="header">
                            <tr>
                                <th>
                                    Test
                                </th>
                            </tr>
                        </ng-template>
                        <ng-template pTemplate="body" let-row>
                            <tr (click)="Setlabitem(row)">
                                <td>
                                    {{row.testDescription}}
                                </td>
                            </tr>
                        </ng-template>


                    </p-table>
                </div>
                <div class="col-10 card">

                    <p-table *ngIf="arrlabdetails"
                             [responsive]="true"
                             [columns]="cols"
                             [value]="arrlabdetails"
                             selectionMode="single"
                             [scrollable]="true"
                             [resetPageOnSort]="false"
                             [lazy]="false"
                             [rows]="rows"
                             [paginator]="false"
                             [autoLayout]="true">
                        <ng-template pTemplate="header" let-columns>
                            <tr>
                                <th *ngFor="let col of columns">
                                    {{ Getheader(col.header) }}
                                </th>
                                <th></th>
                            </tr>
                        </ng-template>
                        <ng-template pTemplate="body"
                                     let-rowData
                                     let-columns="columns"
                                     let-i="rowIndex">
                            <tr *ngIf="i != 0">
                                <td *ngFor="let col of columns"
                                    [ngClass]="selectCursor(rowData[col.field])"
                                    (click)="setViews(rowData[col.field], col.header, rowData)">
                                    <span class="{{ setSeverity(rowData[col.field]) }}">
                                        {{
                                        Getfield(rowData[col.field])
                                        }}
                                    </span>
                                </td>

                                <!--    <td>
                                    <button pButton
                                            type="button"
                                            icon="pi pi-chart-line"
                                            class="p-button-info"
                                            style="font-size: 0.7em"
                                            (click)="getgraphDetails(rowData)"></button>
                                </td>-->
                            </tr>
                        </ng-template>

                        <ng-template pTemplate="emptymessage">
                            <div class="w-12 bg-white">
                                <div class="" style="text-align: center">
                                    <img _ngcontent-ng-c683320295=""
                                         class="profile-image"
                                         style="border-radius: 50%; width: 10rem; padding-top: 1rem"
                                         src="assets/imagesNew/table_error.png" />
                                </div>
                                <hr style="margin-bottom: 0.5rem" />
                                <div class=""
                                     style="text-align: center; font-size: larger; color: #1d428f">
                                    <i>No records found</i>
                                </div>
                            </div>
                        </ng-template>
                    </p-table>
                </div>
            </div>
        </div>
    </p-dialog>
    }
    @else{
    <p-dialog *ngIf="overlayVisible" [header]="getTitle(selectedGroup?.content)" [(visible)]="overlayVisible" modal="false" [style]="{ width: '1000px', minWidth: '200px' }" [maximizable]="true" (onHide)="overlayVisible = false" [resizable]="true">

        <div style="width:100%;">
            <div class="grid">
                <div class="col-2 card" style="overflow: auto;">
                    <p-table [scrollable]="true" scrollHeight="100vh"
                             [value]="summaryViewData" selectionMode="single" [(selection)]="selectedRow" [metaKeySelection]="true" dataKey="date" [styleClass]="'p-datatable-sm'">
                        <ng-template pTemplate="header">
                            <tr>
                                <th *ngFor="let i of summaryViewColumns">
                                    {{i.label}}
                                </th>
                            </tr>
                        </ng-template>
                        <ng-template pTemplate="body" let-date>
                            <tr (click)="selectEvent(date)">

                                <td *ngFor="let k of summaryViewColumns">
                                    @if(k.type=='date')
                                    {
                                    {{date[k.key] | date }}

                                    }
                                    @else{
                                    {{date[k.key]}}
                                    }

                                </td>

                            </tr>

                        </ng-template>
                    </p-table>
                </div>

                @if(selectedGroup.content!='Documents' && selectedGroup.content!='Images')
                {

                <div class="col-10" style="overflow:auto;">
                    <div>
                        <p-table [columns]="fieldsToDisplayinDetailView" [value]="eventsOnSelectedDate" [styleClass]="'p-datatable-sm'">
                            <ng-template pTemplate="header" let-headers>

                                <tr>

                                    <th *ngFor="let i of headers">{{i.label}}</th>
                                </tr>

                            </ng-template>
                            <ng-template pTemplate="body" let-d>

                                <tr>
                                    <td *ngFor="let i of fieldsToDisplayinDetailView">

                                        <ng-container *ngIf="i.key !== 'isResolved'; else ptflag">
                                            <!--{{ d[i.key] }}-->

                                            <span [ngStyle]="i.key === 'bmi' ? getBMIStyle(d[i.key]) : {}">
                                                {{ d[i.key] }}
                                            </span>
                                        </ng-container>

                                        <ng-template #ptflag>
                                            <ng-container *ngIf="d['isResolved']; else ptflagNo">
                                                Yes
                                            </ng-container>
                                        </ng-template>

                                        <ng-template #ptflagNo>
                                            No
                                        </ng-template>

                                    </td>
                                </tr>

                            </ng-template>
                        </p-table>

                    </div>
                </div>
                }
                @else{
                <div class="col-10" style="height:100vh">
                    <app-pdf-viewer [pdf]="pdf" [showPrintButton]="showPrintButton" [enabledDocumentDownloads]="enabledDocumentDownloads"></app-pdf-viewer>
                </div>
                }
            </div>
        </div>
        <p-footer style="display: flex; justify-content: center">
            <button pButton
                    type="button"
                    icon="ui-icon-close"
                    (click)="overlayVisible = false"
                    label="Cancel"
                    class="ui-button-secondary"></button>
        </p-footer>


    </p-dialog>
    }
</ng-container>





